export default __webpack_public_path__ + "static/media/102-mobile.477eb35d.jpg";